import { ServiceTypeEnum } from 'utils/enums';
import {
  mapChipFieldOptions,
  mapToggleFieldOptions,
  getOptions4Type,
} from 'features/consults/utils/formFields';
import fields from 'features/consults/shared/tabs/Data/formFields';

export const leftPanel = {
  elements: [
    mapToggleFieldOptions(fields.glucosePredefined),
    fields.glucoseFreeText,
    mapToggleFieldOptions(fields.creatininePredefined),
    fields.creatinineFreeText,
    mapToggleFieldOptions(fields.inrPredefined),
    fields.inrFreeText,
    fields.otherLabs,
  ],
};

export const rightPanel = {
  elements: [
    mapChipFieldOptions(
      getOptions4Type(fields.headCtPredefined, ServiceTypeEnum.CLINIC),
    ),
    fields.headCtFreeText,
    mapToggleFieldOptions(fields.ctaHeadPredefined),
    fields.ctaHeadFreeText,
    mapToggleFieldOptions(fields.ctaNeckPredefined),
    fields.ctaNeckFreeText,
    mapChipFieldOptions(fields.ctPerfusionPredefined),
    fields.ctPerfusionFreeText,
    mapToggleFieldOptions(fields.mriPredefined),
    fields.mriFreeText,
    fields.otherImaging,
  ],
};
